import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const navItems = [
  { id: 'home', path: '/' },
  { id: 'pricing', path: '/pricing' }
];

const TabNavigation = () => {
  const { t } = useTranslation();
  
  return (
    <>
      {navItems.map((item) => (
        <NavLink
          key={item.id}
          to={item.path}
          className={({ isActive }) =>
            `inline-flex items-center text-lg px-2 py-1 rounded-md font-medium leading-none transition-colors duration-200 hover:text-primary-500 ${isActive ? 'text-primary-500' : 'text-gray-700'}`
          }
        >
          {t(`navigation.${item.id}`)}
        </NavLink>
      ))}
    </>
  );
};

export default TabNavigation;